import React from 'react'
import LogoUpload from '../../../../components/LogoUpload/LogoUpload'

const AccountantLogo: React.FC = () => {
  return <LogoUpload route="accountant" />
}

export default AccountantLogo
